module.exports = __webpack_public_path__ + "static/media/phonetics_comic.f007ecdf.png";